import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accounts: [],
  loading: false,
  error: null
};

const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    setAccounts: (state, action) => {
      state.accounts = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setAccounts, setLoading, setError } = accountsSlice.actions;
export default accountsSlice.reducer;
